import React from 'react';
import { Paper, Typography } from '@mui/material';

const DashboardBarListCard = ({
  title,
  rows,
  classes,
  emptyLabel = 'Aucune donnee',
  valueFormatter = (value) => value,
  color = '#4f8ef7',
}) => {
  const maxValue = rows?.length ? rows[0].value || 1 : 1;

  return (
    <Paper elevation={0} className={classes.chartCard}>
      <Typography className={classes.cardTitle}>{title}</Typography>

      {!rows?.length ? (
        <Typography className={classes.emptyLine}>{emptyLabel}</Typography>
      ) : (
        rows.map((item) => {
          const widthPct = Math.max(0, Math.min(100, (item.value / maxValue) * 100));
          const barColor = item.color || color;
          return (
            <div key={`${title}-${item.label}`} className={classes.barRow}>
              <div className={classes.barName} title={item.label}>
                {item.label}
              </div>
              <div className={classes.barTrack}>
                <div
                  className={classes.barFill}
                  style={{
                    width: `${widthPct}%`,
                    backgroundColor: barColor,
                  }}
                />
              </div>
              <div className={classes.barValue}>{valueFormatter(item.value)}</div>
            </div>
          );
        })
      )}
    </Paper>
  );
};

export default DashboardBarListCard;
